import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// ==========================================
// 【核心修复】全局重写 push 和 replace 方法
// 解决 NavigationDuplicated 报错
// ==========================================
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        // 如果已经传了回调，保持原样
        return originalPush.call(this, location, onResolve, onReject)
    }
    // 否则，返回一个 Promise，并捕获错误
    return originalPush.call(this, location).catch(err => {
        // 如果是重复导航错误，则忽略它，返回 resolved 状态
        if (err.name === 'NavigationDuplicated') {
            return Promise.resolve()
        }
        // 其他错误继续抛出
        return Promise.reject(err)
    })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject)
    }
    return originalReplace.call(this, location).catch(err => {
        if (err.name === 'NavigationDuplicated') {
            return Promise.resolve()
        }
        return Promise.reject(err)
    })
}
// ==========================================


    const routes = [
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/home',
            name: 'Home',
            component: () => import('@/views/front/Home.vue'),
            meta: {
                title: '首页'
            }
        },
        {
            path: '/about',
            name: 'About',
            component: () => import('@/views/front/About.vue'),
            meta: {
                title: '关于我们'
            }
        },
    ]

    const router = new VueRouter({
        mode: 'hash',
        base: process.env.BASE_URL,
        routes
    })

// 全局前置守卫
    router.beforeEach((to, from, next) => {
        // to.matched.length 为 0 表示没有匹配到任何路由
        if (to.matched.length === 0) {
            next('/') // 重定向到首页
        } else {
            next() // 放行
        }
    })

    /**
     * 重置路由到首页
     * 优化：如果当前已经在首页，则不执行跳转，避免触发冗余导航
     */
    export function resetRouter() {
        const currentPath = router.currentRoute.path
        // 只有当不在 /home 或 / (重定向前) 时才跳转
        if (currentPath !== '/home' && currentPath !== '/') {
            return router.push({ path: '/home' })
        }
        // 如果已经在首页，直接返回一个成功的 Promise
        return Promise.resolve()
    }

    export default router